import { builder } from 'common/js/configs';
import { units } from 'common/js/configs/constants';

export const optOutBtnUnmarshaller = {
  optoutBtn: builder.holder({
    iconColor: builder.color('icon_color', {
      defaultValue: '#FFFFFF',
      l:'',
      d:''
    }),
    position: builder.string('optout_position', {
      of: ['bottom-left', 'bottom-right', 'top-left', 'top-right'],
      possibleValues: [
        {
          name: 'Bottom Left',
          value: 'bottom-left'
        },
        {
          name: 'Bottom Right',
          value: 'bottom-right'
        },
        {
          name: 'Top Left',
          value: 'top-left'
        },
        {
          name: 'Top Right',
          value: 'top-right'
        }
      ],
      defaultValue: 'bottom-left',
      l:'',
      d:''
    }),
    iconSize: builder.number('optout_btn_size', {
      defaultValue: 12,
      l:'',
      d:'',
      unit: units.pixel
    }),
    paddingSize: builder.number('optout_btn_padding_size', {
      defaultValue: 4,
      l:'',
      d:'',
      unit: units.pixel
    })
  })
};
